import { AddLink, DeleteButton, EditLink } from "app/components/buttons";
import { Column } from "app/components/column";
import { Container } from "app/components/container";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { Row } from "app/components/row";
import { Table } from "app/components/table";
import { useEmpresa } from "app/contexts";

export function PaginasWebTable() {
  const { empresa, deletePaginaWeb } = useEmpresa();

  return (
    <Container>
      <Row>
        <Column>
          <DFlexResponsive justifyContent="between">
            <h5>
              <strong>Direcciones de página web (opcional)</strong>
            </h5>

            <AddLink
              to="paginas-web/add"
              title="Agregar dirección de página web"
            />
          </DFlexResponsive>
        </Column>

        <Column>
          {!!empresa.paginas_web.length ? (
            <Table
              responsive
              titles={["#", "Dirección de página web", "Opciones"]}
            >
              {empresa.paginas_web.map((pagina, i) => (
                <tr key={i}>
                  <td className="text-center">{i + 1}</td>

                  <td className="text-center">
                    {pagina.pagina_web_principal ? "Principal" : "Secundaria"}
                  </td>

                  <td>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={pagina.pagina_web_url}
                    >
                      {pagina.pagina_web_url}
                    </a>
                  </td>

                  <td>
                    <DFlexResponsive>
                      <EditLink to={`paginas-web/${i}/edit`} />

                      <DeleteButton
                        size="sm"
                        onClick={() => deletePaginaWeb(i)}
                      />
                    </DFlexResponsive>
                  </td>
                </tr>
              ))}
            </Table>
          ) : (
            <p className="lead text-center">
              Por favor, agregue una dirección de página web.
            </p>
          )}
        </Column>
      </Row>
    </Container>
  );
}
